
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/toursinner",
      function () {
        return require("private-next-pages/toursinner/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/toursinner"])
      });
    }
  